module.exports = __webpack_public_path__ + "img/jcb.6ea66db9.svg";